import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Header } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Message } from 'components';
import { colors } from '../../../../utils/colors';
import { translateText } from '../../../../utils/helpers';
import { translation } from '../../../Translation/scorecard';
import EquityTable from '../../Analytics/components/EquityStyleTable';
import PriceMultiples from '../../Analytics/components/PriceMultiples';

class EquityStyle extends Component {
  renderMessage = (message) => {
    const { french } = this.props;

    if (typeof message !== 'string') {
      return null; // or some default message
    }

    return (
      <Message visible warning className="msg">
        {translateText(message, french)}
      </Message>
    );
  };

  render() {
    const { data, benchmark, language, french } = this.props;
    const equityStyle = { ...data.partialCorr['G.EQ'] };
    delete equityStyle.ignoredNegFac;

    const { priceMultiples } = data;
    const portfolioMultiples = priceMultiples.portfolio;
    const benchmarkMultiples = priceMultiples[benchmark]; // use the benchmark chosen by the user
    return (
      <Container>
        <div style={{ marginBottom: '2rem' }}>
          <Header
            dividing
            size="large"
            content={translation[language].STYLE_TAB.header}
            subheader={translation[language].STYLE_TAB.subheader}
          />
          <Header>{translation[language].EQUITYSTYLE.title}</Header>
          <p style={{ paddingBottom: '1rem' }}>
            {translation[language].EQUITYSTYLE.description1} <br /> <br />
            {translation[language].EQUITYSTYLE.description2}
          </p>
          {data.partialCorr && typeof data.partialCorr['G.EQ'] === 'string' ? (
            this.renderMessage(data.partialCorr['G.EQ'])
          ) : (
            <div>
              <EquityTable data={equityStyle} french={french} />
              <Header
                size="small"
                style={{ marginBottom: '2.5rem', color: colors.darkGrey }}
              >
                {translation[language].EQUITYSTYLE_INTERPRETATION.title}
                <ul>
                  <li>
                    {translation[language].EQUITYSTYLE_INTERPRETATION.bullet1}
                  </li>
                  <li>
                    {translation[language].EQUITYSTYLE_INTERPRETATION.bullet2}
                  </li>
                  <li>
                    {translation[language].EQUITYSTYLE_INTERPRETATION.bullet3}
                  </li>
                </ul>
              </Header>
            </div>
          )}
          <Header style={{ marginTop: '3rem' }}>
            {translation[language].PRICEMULTIPLES.title}
          </Header>
          <p style={{ paddingBottom: '2rem' }}>
            {translation[language].PRICEMULTIPLES.description1}
            <br />
            <br />
            {translation[language].PRICEMULTIPLES.note}
          </p>
          {priceMultiples && priceMultiples.msg.length > 0 ? (
            this.renderMessage(priceMultiples.msg)
          ) : (
            <PriceMultiples
              portfolio={portfolioMultiples}
              benchmark={benchmarkMultiples}
              pdf
            />
          )}
        </div>
      </Container>
    );
  }
}

EquityStyle.propTypes = {
  data: PropTypes.object,
  french: PropTypes.bool,
  language: PropTypes.string,
  benchmark: PropTypes.string,
};

EquityStyle.defaultProps = {
  data: {},
  french: false,
  language: 'en',
  benchmark: '',
};

export default connect((state) => ({
  data: state.Analytics.data,
  french: state.Storage.language === 'fr',
  language: state.Storage.language,
  benchmark: state.Analytics.benchmark,
}))(EquityStyle);

const Container = styled.div`
  padding: 2rem 2rem 1rem 2rem;

  ul {
    font-weight: normal;
    margin: 0;
  }
  .msg {
    width: fit-content;
  }
`;
